namespace Gamification.Administration {
    export interface UserForm {
        Username: Serenity.StringEditor;
        Password: Serenity.PasswordEditor;
        PasswordConfirm: Serenity.PasswordEditor;
        Cognome: Serenity.StringEditor;
        Nome: Serenity.StringEditor;
        DisplayName: Serenity.StringEditor;
        Email: Serenity.EmailAddressEditor;
        IdAzienda: Serenity.LookupEditor;
        Api: Serenity.LookupEditor;
        MobilePhoneNumber: Serenity.StringEditor;
        MobilePhoneVerified: Serenity.BooleanEditor;
        TwoFactorAuth: Serenity.EnumEditor;
        UserImage: Serenity.ImageUploadEditor;
        IsActive: Serenity.BooleanEditor;
        Roles: Serenity.LookupEditor;
        Source: Serenity.StringEditor;
    }

    export class UserForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.User';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!UserForm.init)  {
                UserForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.PasswordEditor;
                var w2 = s.EmailAddressEditor;
                var w3 = s.LookupEditor;
                var w4 = s.BooleanEditor;
                var w5 = s.EnumEditor;
                var w6 = s.ImageUploadEditor;

                Q.initFormType(UserForm, [
                    'Username', w0,
                    'Password', w1,
                    'PasswordConfirm', w1,
                    'Cognome', w0,
                    'Nome', w0,
                    'DisplayName', w0,
                    'Email', w2,
                    'IdAzienda', w3,
                    'Api', w3,
                    'MobilePhoneNumber', w0,
                    'MobilePhoneVerified', w4,
                    'TwoFactorAuth', w5,
                    'UserImage', w6,
                    'IsActive', w4,
                    'Roles', w3,
                    'Source', w0
                ]);
            }
        }
    }
}
